import { CuriosityNamespaceType, CuriosityValue2 } from '@procureai/curiosity-ui-mui';
import { CuriosityTreeSelectField } from '@procureai/ui-form-mui/fields';
import { NavListItem, NavListItemToolTipContent } from '@procureai/ui-mui';
import { Popover, PopoverContent, PopoverTrigger, Typography } from '@procureai/uix';
import { WorkflowIcon } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';
import { useActiveScope } from '~/hooks/useActiveScope/useActiveScope';

export const NavListItemScopeSelect = () => {
  const { t } = useTranslation(I18nNamespace.common);
  const { activeScope, setActiveScope } = useActiveScope();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger
        nativeButton={false}
        render={
          <NavListItem
            tooltip={
              <NavListItemToolTipContent
                label={
                  activeScope && (
                    <CuriosityValue2
                      ns={CuriosityNamespaceType.DATA_ACCESS_SCOPE}
                      i18nKey={activeScope}
                      fallback={null}
                      loading={null}
                    />
                  )
                }
              />
            }
          >
            <div className="flex w-full items-center justify-center">
              <WorkflowIcon size={16} />
            </div>
          </NavListItem>
        }
      />
      <PopoverContent side="right" align="center" className="w-[260px] p-2">
        <div className="space-y-1.5">
          <Typography variant="caption" className="text-muted-foreground">
            {t('Nav.activeScope', 'Scope')}
          </Typography>
          <CuriosityTreeSelectField
            ns={CuriosityNamespaceType.DATA_ACCESS_SCOPE}
            value={activeScope}
            onChange={(value) => setActiveScope(typeof value === 'string' ? value : null)}
            placeholder={t('Nav.activeScopePlaceholder', 'Select scope')}
          />
        </div>
      </PopoverContent>
    </Popover>
  );
};
